import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import nameTemplate from 'properties/main/file_types.ejs';


class MainFileTypesView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #filetypes' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.updateForm);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('filetypes')) {
            $('#filetypes').find('option[value='+this.model.get('filetypes')+']').attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }

    updateForm() {
        //set selected index to model value
        if(this.model.get('filetypes')) {
            $('#filetypes').find("option[value='"+this.model.get('filetypes')+"']").attr('selected', true);
        }
    }

}

export default MainFileTypesView;
